"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IccClassificationTemplateApi = void 0;
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
const XHR_1 = require("./XHR");
const ClassificationTemplate_1 = require("../model/ClassificationTemplate");
const DocIdentifier_1 = require("../model/DocIdentifier");
const PaginatedListClassificationTemplate_1 = require("../model/PaginatedListClassificationTemplate");
class IccClassificationTemplateApi {
    constructor(host, headers, fetchImpl) {
        this.host = host;
        this.headers = Object.keys(headers).map((k) => new XHR_1.XHR.Header(k, headers[k]));
        this.fetchImpl = fetchImpl;
    }
    setHeaders(h) {
        this.headers = h;
    }
    handleError(e) {
        throw e;
    }
    /**
     * Returns an instance of created classification Template.
     * @summary Create a classification Template with the current user
     * @param body
     */
    createClassificationTemplate(body) {
        let _body = null;
        _body = body;
        const _url = this.host + `/classificationTemplate` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ClassificationTemplate_1.ClassificationTemplate(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Response is a set containing the ID's of deleted classification Templates.
     * @summary Delete classification Templates.
     * @param classificationTemplateIds
     */
    deleteClassificationTemplates(classificationTemplateIds) {
        let _body = null;
        const _url = this.host + `/classificationTemplate/${encodeURIComponent(String(classificationTemplateIds))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('DELETE', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new DocIdentifier_1.DocIdentifier(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     * Keys hast to delimited by coma
     * @summary List classification Templates found By Healthcare Party and secret foreign keyelementIds.
     * @param hcPartyId
     * @param secretFKeys
     */
    findClassificationTemplatesByHCPartyPatientForeignKeys(hcPartyId, secretFKeys) {
        let _body = null;
        const _url = this.host +
            `/classificationTemplate/byHcPartySecretForeignKeys` +
            '?ts=' +
            new Date().getTime() +
            (hcPartyId ? '&hcPartyId=' + encodeURIComponent(String(hcPartyId)) : '') +
            (secretFKeys ? '&secretFKeys=' + encodeURIComponent(String(secretFKeys)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new ClassificationTemplate_1.ClassificationTemplate(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     *
     * @summary Get a classification Template
     * @param classificationTemplateId
     */
    getClassificationTemplate(classificationTemplateId) {
        let _body = null;
        const _url = this.host + `/classificationTemplate/${encodeURIComponent(String(classificationTemplateId))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ClassificationTemplate_1.ClassificationTemplate(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Ids are seperated by a coma
     * @summary Get a list of classifications Templates
     * @param ids
     */
    getClassificationTemplateByIds(ids) {
        let _body = null;
        const _url = this.host + `/classificationTemplate/byIds/${encodeURIComponent(String(ids))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => doc.body.map((it) => new ClassificationTemplate_1.ClassificationTemplate(it)))
            .catch((err) => this.handleError(err));
    }
    /**
     * Returns a list of classification templates.
     * @summary List all classification templates with pagination
     * @param startKey A label
     * @param startDocumentId An classification template document ID
     * @param limit Number of rows
     */
    listClassificationTemplates(startKey, startDocumentId, limit) {
        let _body = null;
        const _url = this.host +
            `/classificationTemplate` +
            '?ts=' +
            new Date().getTime() +
            (startKey ? '&startKey=' + encodeURIComponent(String(startKey)) : '') +
            (startDocumentId ? '&startDocumentId=' + encodeURIComponent(String(startDocumentId)) : '') +
            (limit ? '&limit=' + encodeURIComponent(String(limit)) : '');
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new PaginatedListClassificationTemplate_1.PaginatedListClassificationTemplate(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Returns the modified classification Template.
     * @summary Modify a classification Template
     * @param body
     */
    modifyClassificationTemplate(body) {
        let _body = null;
        _body = body;
        const _url = this.host + `/classificationTemplate` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ClassificationTemplate_1.ClassificationTemplate(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * It delegates a classification Template to a healthcare party (By current healthcare party). Returns the element with new delegations.
     * @summary Delegates a classification Template to a healthcare party
     * @param body
     * @param classificationTemplateId
     */
    newClassificationTemplateDelegations(classificationTemplateId, body) {
        let _body = null;
        _body = body;
        const _url = this.host + `/classificationTemplate/${encodeURIComponent(String(classificationTemplateId))}/delegate` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new ClassificationTemplate_1.ClassificationTemplate(doc.body))
            .catch((err) => this.handleError(err));
    }
}
exports.IccClassificationTemplateApi = IccClassificationTemplateApi;
//# sourceMappingURL=IccClassificationTemplateApi.js.map